const sources = {
  home: 'https://px.ads.linkedin.com/collect/?pid=1430129&conversionId=1249281&fmt=gif',
  contact: 'https://px.ads.linkedin.com/collect/?pid=1430129&conversionId=1249297&fmt=gif',
  holiday2019: 'https://px.ads.linkedin.com/collect/?pid=1430129&conversionId=1249289&fmt=gif'
}

export default function(source) {
  const imgTag = document.createElement('img')
  imgTag.height = '1'
  imgTag.width = '1'
  imgTag.style = 'display:none;'
  imgTag.src = sources[source]

  document.body.appendChild(imgTag)
}



// WEBPACK FOOTER //
// ./client/events/linkedInEvent.js